import classnames from 'classnames';

import { ListItemButton as MuiListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import { makeStyles } from '@mui/styles';

const useStyles = /* istanbul ignore next */ makeStyles(
  ({ palette, typography }) => ({
    iconContainerOnRight: {
      alignSelf: 'baseline',
      marginRight: 0,
    },
    itemSelected: {
      backgroundColor: palette.action.selected,
      pointerEvents: 'none',
    },
    listItemContainer: {
      listStyle: 'none',
    },
    listItem: {
      color: 'inherit !important',
    },
    primary: {
      fontWeight: typography.fontWeightRegular,
    },
  }),
  { classNamePrefix: 'ListItem' }
);

function ListItem({
  children = null,
  className = '',
  Component = 'div',
  icon: ItemIcon = null,
  isIconOnRight = false,
  label,
  selected = false,
  ...otherProps
}) {
  const classes = useStyles();

  const iconContainerClassname = classnames({
    [classes.iconContainerOnRight]: isIconOnRight,
  });

  let iconElement = null;

  if (ItemIcon) {
    iconElement = isIconOnRight ? (
      <ItemIcon />
    ) : (
      <ListItemIcon className={iconContainerClassname}>
        <ItemIcon />
      </ListItemIcon>
    );
  }

  const listItemContainerClassName = classnames(className, classes.listItemContainer, {
    [classes.itemSelected]: selected,
  });

  return (
    <li className={listItemContainerClassName}>
      <MuiListItemButton className={classes.listItem} component={Component} {...otherProps}>
        {!isIconOnRight && iconElement}
        <ListItemText classes={{ primary: classes.primary }} primary={label} />
        {children}
        {isIconOnRight && iconElement}
      </MuiListItemButton>
    </li>
  );
}

export default ListItem;
